
function doFunction() {

    this.$eventBus.emit('show-dialog-page', {
      page: 'pdrs-carica-consumi-file',
      title: 'Caricamento Consumi GAS',
      data: {type:'gas'},
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': doFunction,
}
